module.exports = __webpack_public_path__ + "img/neowalls_image.e0bf0cf5.jpg";